var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.885,88.276H38.115C17.045,88.399,0,105.515,0,126.615v258.759 c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.615 C512,105.515,494.955,88.399,473.885,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M498.304,97.249l-484.6,317.496c6.665,5.597,15.257,8.972,24.641,8.972h435.31 c21.177,0,38.345-17.167,38.345-38.345V126.614C512,114.825,506.675,104.284,498.304,97.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M512,97.103c0-4.875-3.953-8.828-8.828-8.828h-15.339L0,407.891v7.006 c0,4.875,3.953,8.828,8.828,8.828h15.339L512,104.109V97.103z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M44.429,115.778l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C46.805,114.419,44.883,114.419,44.429,115.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M158.21,115.778l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C160.585,114.419,158.663,114.419,158.21,115.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M101.32,166.476l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C103.694,165.117,101.773,165.117,101.32,166.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M44.429,217.174l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C46.805,215.815,44.883,215.815,44.429,217.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M158.21,217.174l-4.726,14.169l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.015,8.873 l-4.505,14.241c-0.433,1.366,1.123,2.495,2.289,1.663l12.152-8.685l12.152,8.685c1.165,0.833,2.72-0.297,2.289-1.663l-4.505-14.241 l12.015-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.169C160.585,215.815,158.663,215.815,158.21,217.174z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.2b30bda5aef7dc2d45100c405fac1041.svg";
export { ForwardRef as ReactComponent };